import { ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import type { MailOutboxItem } from "@/lib/notification.api";
import { getMailOutboxSourceLink } from "../mailOutboxPage.helpers";

interface MailOutboxSourceLinkProps {
  item: MailOutboxItem;
}

export function MailOutboxSourceLink({ item }: MailOutboxSourceLinkProps) {
  const { label, href } = getMailOutboxSourceLink(item);

  if (!href) {
    return <span className="text-[12px] text-subtle">{label}</span>;
  }

  return (
    <Link
      to={href}
      className="inline-flex items-center gap-1 text-[12px] text-info-text hover:underline"
    >
      {label}
      <ExternalLink size={11} />
    </Link>
  );
}
